import { render, staticRenderFns } from "./BillDeliveryField.vue?vue&type=template&id=649874e2&"
import script from "./BillDeliveryField.vue?vue&type=script&lang=js&"
export * from "./BillDeliveryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports